import React from 'react';
import Navbar from './components/Navbar';
import HeroRealEstate from './components/HeroRealEstate';
import TrustSection from './components/TrustSection';
import PropertyGrid from './components/PropertyGrid';
import BenefitsSection from './components/BenefitsSection';
import HowItWorks from './components/HowItWorks';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ThankYouPage from './components/ThankYouPage';

const App: React.FC = () => {
  const pathname = window.location.pathname.replace(/\/$/, '');
  const isThankYouPage = pathname === '/thank-you' || pathname === '/thank-you.html';

  if (isThankYouPage) {
    return <ThankYouPage />;
  }

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main id="main-content">
        <HeroRealEstate />
        <TrustSection />
        <PropertyGrid />
        <BenefitsSection />
        <HowItWorks />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default App;
